import { useEffect } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import BannersGrid from '../BannersGrid';
import BestSellingDescription from '../BestSeller/BestSellingDescription';
import ProductCard from '../ProductCard';
import { BestSeller, CardHorizontalScroll, RelativeContainer } from './styled';

function BestSellerComponent(props) {
  const { data, type, setChangeCartCount, showPrice, parentIndex } = props;

  useEffect(() => {
    cardServedEvent(data);
  }, []);
  return (
    <>
      <BestSeller
        sectionBgColorEnd={data?.sectionBgColorEnd}
        sectionBgColorStart={data?.sectionBgColorStart}
      >
        <RelativeContainer>
          <BestSellingDescription data={data} />{' '}
          {type == 'banner' ? (
            <CardHorizontalScroll>
              <BannersGrid type="bestSeller" banner={data} />
            </CardHorizontalScroll>
          ) : (
            <AnywhereHorizontalScroll
              firstElementId={`${data?.heading}first`}
              lastElementId={`${data?.heading}last`}
              leftArrow={<img src={images.arrowdownforward} alt="" />}
              rightArrow={<img src={images.arrowdownforward} alt="" />}
              scrolledWidth={440}
            >
              {data?.items?.map((element, index) => {
                return (
                  <ProductCard
                    itemId={`element-${index}`}
                    key={`element-${index}`}
                    productData={element}
                    setChangeCartCount={setChangeCartCount}
                    card={element}
                    sectionName={data?.heading}
                    sectionId={data?._id}
                    showPrice={showPrice}
                    index={index}
                    mobileMaxWidth={'210px'}
                    mobileMinWidth={'210px'}
                    length={data?.items?.length}
                    maxWidth={'23%'}
                    shrink={'0'}
                    storeHome={true}
                    type={data?.viewType}
                    parentIndex={parentIndex}
                  />
                );
              })}
            </AnywhereHorizontalScroll>
          )}
        </RelativeContainer>
      </BestSeller>
    </>
  );
}

export default BestSellerComponent;
